export default "__VITE_ASSET__b6530599__"